define(function (require) {

    window.lpTag = window.lpTag || {};
    window.lpTag.WebAgent = window.lpTag.WebAgent || {};

    var PARTICIPANTS_ROLES = lpTag.AMSStatics.participant.roles;

    var _ = require('underscore');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var WebAgentUtils = require('web-agent-utils/WebAgentUtils');
    var lpAMSController = require('web-agent-assets-js/lpAMSController');
    var lpUtils = require('utils/lpUtils');

    var LPClassesMap = {
        chat_open: 'chat_open',
        chat_close: 'chat_close',
        hyperlink: 'bluelink'
    };

    /**
     * translate web agent keys - key will be prefixed with LEWebAgent before send to translation
     * key {String} translation key
     * @private
     * @returns {String}
     */
    function _translate(key) {
        return agentLEManager.translateLE('LEWebAgent.' + key);
    }

    /**
     * translate web agent keys and arguments - key will be prefixed with LEWebAgent before send to translation
     * key {String} translation key
     * args {array} translation arguments
     * @private
     * @returns {String}
     */
    function _translateObj(key, args) {
        return agentLEManager.translateLE({ key: 'LEWebAgent.' + key, args: args});
    }

    /**
     * Returns state object with proper values for table rendering
     * @param {String} state conversation state
     * @param {String=} closeReason who ended the conversation
     * @public
     * @returns {state: String, stateTooltip: String, closeReason: String=}
     */
    function getStateValues (state, closeReason) {
        var values = {};

        values.closeReason = "";

        if (state) {
            switch (state) {
                case lpTag.WebAgent.logicController.conversationStates.OPEN:
                    values.state = LPClassesMap.chat_open;
                    values.stateTooltip = _translate('STATE_IN_CONVERSATION');
                    break;
                case lpTag.WebAgent.logicController.conversationStates.CLOSE:
                case lpTag.WebAgent.logicController.conversationStates.LOCKED:
                    values.state = LPClassesMap.chat_close;
                    switch (closeReason) {
                        case lpTag.WebAgent.logicController.conversationCloseReasons.AGENT:
                            values.closeReason = "(" + _translate('CLOSE_REASON_AGENT') + ")";
                            values.stateTooltip = _translate('STATE_CLOSED_CONVERSATION_AGENT');
                            break;
                        case lpTag.WebAgent.logicController.conversationCloseReasons.CONSUMER:
                            values.closeReason = "(" + _translate('CLOSE_REASON_CONSUMER') + ")";
                            values.stateTooltip = _translate('STATE_CLOSED_CONVERSATION_CONSUMER');
                            break;
                        case lpTag.WebAgent.logicController.conversationCloseReasons.TIMEOUT:
                        case lpTag.WebAgent.logicController.conversationCloseReasons.SYSTEM:
                            values.closeReason = "(" + _translate('CLOSE_REASON_TIMEOUT') + ")";
                            values.stateTooltip = _translate('STATE_CLOSED_CONVERSATION_TIMEOUT');
                            break;
                        default:
                            values.stateTooltip = _translate('STATE_CLOSED_CONVERSATION');
                            break;
                    }
                    break;
                default:
                    //should not happen
                    values.state = state.toLowerCase();
                    values.stateTooltip = _translate('notAvailable');
                    break;
            }
        } else {
            var notAvailableMsg = _translate('notAvailable');
            values.state = notAvailableMsg;
            values.stateTooltip = notAvailableMsg;
        }

        return values;
    }

    /**
     * Returns badges object with proper values for table rendering
     * @param {Object} badges
     * @param {String} state conversation state
     * @param {Boolean=} isAlmostOverdue
     * @public
     * @returns {{badges: String=, firstTimeTooltip: String, urgentTooltip: String, overdueTooltip: String, inQueueTooltip: String, almostOverdue:String=}}
     */
    function getBadgesValues (badges, state, isAlmostOverdue) {

        var values = {
            badges: '',
            inSurveyTooltip: _translate('IN_SURVEY_CONVERSATION'),
            firstTimeTooltip: _translate('FIRST_TIME_CONVERSATION'),
            urgentTooltip: _translate('URGENT_CONVERSATION'),
            overdueTooltip: _translate('OVERDUE_CONVERSATION'),
            inQueueTooltip: _translate('IN_QUEUE_CONVERSATION')
        };

        if (badges && (state === lpTag.WebAgent.logicController.conversationStates.OPEN)) {
            _.forOwn(badges, function(badgeValue, badgeName){
                if(badgeValue) {
                    values.badges += "show_" + badgeName + "_badge ";
                }

                if (isAlmostOverdue  || (badgeName === "overdue" && badgeValue)) {
                    values.almostOverdue = "almost_overdue";
                }
            });
        }

        return values;
    }

    /**
     * Returns consumer object with proper values for table rendering
     * @param {String} name consumer name
     * @param {String=} phoneNumber consumer phone num
     * @param {String=} imgUrl url for avatar image
     * @returns {{name: String, phoneNumber: String, customImage: String, showImage: String, consumerLinkClassName: String, phoneNumber: String}}
     */
    function getConsumerInfo (name, phoneNumber, imgUrl, enableLink) {

        var info = {
            name: name || _translate('participantDefaultName'),
            customImage: '',
            showImage: "showDefaultImage",
            consumerLinkClassName: enableLink ? LPClassesMap.hyperlink : '',
            phoneNumber: phoneNumber
        };
        // Avatar
        if (imgUrl && WebAgentUtils.isSecureUrl(imgUrl)) {
            info.customImage = "<img class=\'customImage\' src=\'" + imgUrl + "\'>";
            info.showImage = "showCustomImage";
        }

        return info;
    }


    /**
     * Returns participant info object with proper values for table rendering
     * @param {String=} serialNumber participant serial number
     * @param {String=} tag participant tag
     * @returns {{serialNumber: String, participantTag: String}}
     */
    function getParticipantInfo (serialNumber, tag) {

        return {
            serialNumber: serialNumber,
            participantTag: tag || "grey"
        };

    }

    /**
     * Returns unread messages object with proper values for table rendering
     * @param {Number=} loggedInAgentUnreadCount
     * @returns {{unreadStatusClassName: string, unreadStatusTooltip: string, loggedInAgentUnreadCount: number=}}
     */
    function getUnreadMessagesValues (loggedInAgentUnreadCount) {
        var values = {
            unreadStatusClassName: loggedInAgentUnreadCount ? "unread_icon" : "hide",
            unreadStatusTooltip: loggedInAgentUnreadCount ? _translate('unreadMessages') : ""
        };
        if(loggedInAgentUnreadCount) {
            values.loggedInAgentUnreadCount = loggedInAgentUnreadCount;
        }
        return values;
    }

    /**
     * Formats the last message time text and tooltip as follows:
     * plain text ==> "<text>"
     * form invitation ==> "<agent full name> has sent you a Secure Form: <form name>"
     * form submission ==> "The secure form has been submitted"
     * image (hosted/export) ==> [image] "<caption text>"
     * rich content ==> [Rich content]
     * @param {Object} eventData
     * @param {String} originatorId
     * @returns {{formattedMessageText: String, formattedMessageTextTooltip: String}}
     */
    function formatLastMessage(eventData, originatorId) {

        var formattedText = '';
        var formattedTextTooltip = '';

        if (eventData) {
            switch (eventData.contentType) {
                //plain text
                case lpAMSController.CONTENT_TYPES.TEXT_PLAIN:
                    formattedText = eventData.message || eventData.text;
                    break;
                //images
                case lpAMSController.CONTENT_TYPES.EXTERNAL_FILE:
                case lpAMSController.CONTENT_TYPES.HOSTED_FILE:
                    var msg = eventData.message || eventData.event.message;
                    if (msg) {
                        if (getParentFileType(msg.fileType) === lpAMSController.FILE_TYPES.AUDIO) {
                            formattedText = '[' + _translate('audio_messaging_caption') + ']';
                        } else {
                            formattedText = '[' + _translate('photo_sharing_image_caption') + ']';
                        }

                        if (msg.caption) {
                            formattedText += ' "' + msg.caption + '"';
                        }
                    }
                    break;
                //PCI form
                case lpAMSController.CONTENT_TYPES.SECURE_FORM_SUBMISSION:
                    formattedText = eventData.text || getSubmissionText();
                    break;
                case lpAMSController.CONTENT_TYPES.SECURE_FORM_INVITATION:
                    formattedText = eventData.text || getInvitationText();
                    break;
                //rich content
                case lpAMSController.CONTENT_TYPES.RICH_CONTENT:
                    formattedText = '[' + _translate('structured_content_plain_text') + ']';
                    break;
                default:
                    formattedText = '...';
                    break;
            }

            // raw output from the backend - sanitize it
            formattedText = WebAgentUtils.sanitizeText(formattedText).text;
            formattedTextTooltip = lpTag.WebAgent.smileyEmojisController.removeEmojisFromText(formattedText).trim();

            if (eventData.contentType === lpAMSController.CONTENT_TYPES.TEXT_PLAIN ||
                eventData.contentType === lpAMSController.CONTENT_TYPES.SECURE_FORM_SUBMISSION ||
                eventData.contentType === lpAMSController.CONTENT_TYPES.SECURE_FORM_INVITATION ) {
                    formattedTextTooltip = '"' + formattedTextTooltip + '"';
            }
        }

        return {
            formattedMessageText : formattedText,
            formattedMessageTextTooltip: formattedTextTooltip
        };


        function getSubmissionText() {
            var secureFormName = getSecureFormName();
            if (secureFormName) {
                return _translateObj('secure_form_submit_event_text', [{
                    isTranslate: false,
                    key: secureFormName
                }]);
            }
            return _translate('secure_form_submit_event_text_generic');
        }

        function getInvitationText() {
            return _translateObj('secure_form_send_event_text',
                    [{
                        isTranslate: false,
                        key: getAgentName()
                    }, {
                        isTranslate: false,
                        key: eventData.message.title
                    }]
            );
        }

        function getSecureFormName() {
            var currentSecureForm = lpTag.WebAgent.secureFormsController.getSecureFormData(eventData.message.invitationId);
            if (currentSecureForm) {
                return currentSecureForm.secureFormName;
            }
        }

        function getAgentName() {
            var userProfiles = lpTag.WebAgent.AppMediator.getModelParam('userProfiles');
            var origId = originatorId.split('.');
            if (origId.length !== 2) {
                return;
            }
            var accountId = origId[0];
            var repId = origId[1];
            if (userProfiles && userProfiles[accountId] && userProfiles[accountId][repId]) {
                return userProfiles[accountId][repId].fullName;
            }
        }
    }

    /**
     * converts a value to its value in languino by number
     * @param {Number} num
     */
    function getEngagementSourceByEnum(num) {
        if (_.isNaN(num)) {
            return '';
        }

        var engagementSources = require("assets/data/sharedData/engagementSourceEnum.json");
        var engagementSourceName = _.findKey(engagementSources.ENGAGEMENT_SOURCE, function (e) { return e === num; });

        if (!engagementSourceName) {
            return '';
        }

        return _translate('VISIT_INFO_offsite_' + engagementSourceName);
    }


    /**
     * converts a value to its value in languino by key
     * @param {String} key
     */
    function getEngagementSourceByKey(key) {
        if (!key || typeof key !== 'string') {
            return '';
        }

        return _translate('VISIT_INFO_offsite_' + key);
    }

    function getConversationOriginContext(conversation) {
        if (!conversation || !conversation.conversationDetails || !conversation.conversationDetails.context ) { return; }
        return conversation.conversationDetails.context.originConversationContext || conversation.conversationDetails.context;
    }

    function getParentFileType(fileType) {
        switch (fileType && fileType.toUpperCase()) {
            case lpAMSController.FILE_TYPES.IMG:
            case lpAMSController.FILE_TYPES.JPG:
            case lpAMSController.FILE_TYPES.TIF:
            case lpAMSController.FILE_TYPES.PNG:
            case lpAMSController.FILE_TYPES.JPEG:
            case lpAMSController.FILE_TYPES.GIF:
                return lpAMSController.FILE_TYPES.IMG;
            case lpAMSController.FILE_TYPES.M4A:
            case lpAMSController.FILE_TYPES.AAC:
            case lpAMSController.FILE_TYPES.MP3:
            case lpAMSController.FILE_TYPES.AVI:
            case lpAMSController.FILE_TYPES.PCM:
            case lpAMSController.FILE_TYPES.AUDIO:
                return lpAMSController.FILE_TYPES.AUDIO;
            default:
                return lpAMSController.FILE_TYPES.OTHER;
        }
    }


    function getParticipantFullName(firstName, lastName, role, enableBlockVisitorName) {
        var fullName;
       if (role === PARTICIPANTS_ROLES.CONSUMER && enableBlockVisitorName) {
           fullName = agentLEManager.translateLE('LEWebAgent.participantDefaultName');
       } else if(role === PARTICIPANTS_ROLES.CONTROLLER) {
           fullName = agentLEManager.translateLE('LEWebAgent.autoMessageBotDefaultName');
       } else if (firstName && lastName) {
           fullName = firstName + " " + lastName;
       } else if (!firstName && lastName) {
           fullName = lastName;
       } else if (firstName && !lastName) {
           fullName = firstName;
       } else {
           switch (role) {
               case PARTICIPANTS_ROLES.CONSUMER:
                   fullName = agentLEManager.translateLE('LEWebAgent.participantDefaultName');
                   break;
               case PARTICIPANTS_ROLES.ASSIGNED_AGENT:
               case PARTICIPANTS_ROLES.MANAGER:
               case PARTICIPANTS_ROLES.READER:
                   fullName =  agentLEManager.translateLE('LEWebAgent.agentDefaultName');
                   break;
               default:
                   fullName = agentLEManager.translateLE('LEWebAgent.participantDefaultName');
           }
       }
       return fullName;
   }

    function isConversationOverdue(timestamp, status) {
        if (isNaN(timestamp)) {
            return;
        }
        if (timestamp === -1 || status === "CLOSE") {
            return false;
        }
        return timestamp - (new Date()).getTime() <= 0;
    }

    function generateUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    function calculateChannelSource(conversationContext) {
        if (!conversationContext) {
            return;
        }
        var clientProperties = conversationContext.clientProperties;
        var contextName = conversationContext.name || conversationContext.type;
        if (contextName) {
            contextName = contextName.toLowerCase();
        }

        switch (contextName) {
            case 'line':
            case 'google':
            case 'whc':
            case 'plusmessage':
                return getSource({ sourceType: 'source', sourceName: contextName, sourceTitle: agentLEManager.translateLE("LEWebAgent.VISIT_INFO_SOURCE_" + contextName) });
            case 'smscontext':
                return getSource({ sourceType: 'source', sourceName: 'sms', sourceTitle: agentLEManager.translateLE("LEWebAgent.VISIT_INFO_SOURCE_sms") });
            case 'apple business chat':
                return getSource({ sourceType: 'source', sourceName: 'apple', sourceTitle: agentLEManager.translateLE("LEWebAgent.VISIT_INFO_SOURCE_apple")});
            case 'facebookcontext':
                return getSource({ sourceType: 'source', sourceName: 'facebook', sourceTitle: agentLEManager.translateLE("LEWebAgent.VISIT_INFO_SOURCE_facebook") });
            case 'whatsapp':
            case 'whatsapp business':
                return getSource({ sourceType: 'source', sourceName: 'whatsapp', sourceTitle: agentLEManager.translateLE("LEWebAgent.VISIT_INFO_SOURCE_whatsapp") });
            case 'rcs business messaging':
                return getSource({ sourceType: 'source', sourceName: 'rcs', sourceTitle: agentLEManager.translateLE("LEWebAgent.VISIT_INFO_SOURCE_rcs") });
            case 'wechat':
                return getSource({ sourceType: 'source', sourceName: 'wechat', sourceTitle: agentLEManager.translateLE("LEWebAgent.VISIT_INFO_SOURCE_wechat") });
            default:
                break;
        }

        if (clientProperties) {
            if (clientProperties.browser && clientProperties.browser !== "UNKNOWN") {
                return getSource({
                    sourceType: 'browser',
                    sourceName: clientProperties.browser,
                    sourceTitle: clientProperties.browser && lpUtils.capitalize(clientProperties.browser),
                    sourceVersion: clientProperties.browserVersion
                });
            }
            else if (clientProperties.os && clientProperties.os !== "OTHER") {
                return getSource({
                    sourceType: 'os',
                    sourceName: clientProperties.os,
                    sourceTitle: clientProperties.os,
                    sourceVersion: clientProperties.osVersion
                });
            }
            else {
                return getSource({ sourceType: 'unknown', sourceTitle: agentLEManager.translateLE('LEWebAgent.VISIT_INFO_Device_NO_DEVICE') });
            }
        }

        return;

        function getSource(obj) {
            var source = {};
            source.type = obj.sourceType;
            source.value = obj.sourceName;
            source.title = obj.sourceTitle;
            if (obj.sourceVersion) {
                source.title += ' ' + obj.sourceVersion;
            }
            return source;
        }
    }

    function getFeaturesAndIntegrationFromContext(context) {
        var result = {};
        if (context && context.clientProperties) {
            // Converting the features array into an object, so it's easier to look up, and doesn't mess
            // up our model, as arrays tend to do...
            result.features = {};
            if (context.clientProperties.features && context.clientProperties.features.length > 0) {
                context.clientProperties.features.forEach(function (feature) {
                    result.features[feature] = true;
                });
            }
            result.integration = context.clientProperties.integration;
        }
        return result;
    }

    return {
        getStateValues: getStateValues,
        getBadgesValues: getBadgesValues,
        getConsumerInfo: getConsumerInfo,
        getParticipantInfo: getParticipantInfo,
        getUnreadMessagesValues: getUnreadMessagesValues,
        getEngagementSourceByEnum: getEngagementSourceByEnum,
        getEngagementSourceByKey: getEngagementSourceByKey,
        formatLastMessage: formatLastMessage,
        getConversationOriginContext: getConversationOriginContext,
        getParentFileType: getParentFileType,
        getParticipantFullName: getParticipantFullName,
        PARTICIPANTS_ROLES: PARTICIPANTS_ROLES,  // This is to support cross enums (History + UMS)
        isConversationOverdue: isConversationOverdue,
        generateUUID: generateUUID,
        calculateChannelSource: calculateChannelSource,
        getFeaturesAndIntegrationFromContext: getFeaturesAndIntegrationFromContext
    };

});
